import { Link } from 'react-router-dom';

const stats = [
  { value: '10,000+', label: '忠实读者' },
  { value: '500+', label: '原创文章' },
  { value: '50+', label: '合作品牌' },
  { value: '98%', label: '满意度' },
];

export default function Hero() {
  return (
    <section className="relative w-full min-h-[600px] md:min-h-[700px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Elegant%20mature%20woman%20with%20confident%20smile%20standing%20in%20a%20beautiful%20minimalist%20setting%20with%20warm%20golden%20hour%20light%2C%20sophisticated%20lifestyle%20portrait%2C%20neutral%20cream%20and%20beige%20tones%2C%20soft%20bokeh%20background%2C%20flowing%20fabric%20dress%2C%20timeless%20elegance%2C%20editorial%20photography%20quality%2C%20serene%20atmosphere&width=1800&height=1000&seq=hero-main-2026&orientation=landscape"
          alt="熟女魅力 - 成熟女性的时尚与生活美学"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/15 to-black/35"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6">
        <div className="max-w-3xl mx-auto text-center">
          <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-semibold text-white leading-tight mb-6" style={{ fontFamily: 'var(--font-heading)' }}>
            熟女魅力
            <span className="block text-2xl md:text-3xl lg:text-4xl font-normal mt-3 text-background-200">
              成熟女性的时尚与生活美学
            </span>
          </h1>
          <p className="text-base md:text-lg text-background-200/90 max-w-2xl mx-auto mb-10 leading-relaxed font-label">
            探索熟女的独特魅力，从时尚穿搭、护肤保养到生活态度，
            全面解析成熟女性如何展现自信与优雅，让熟女魅力更加耀眼动人
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link
              to="/category/shishang-chuanda"
              className="whitespace-nowrap px-8 py-3.5 bg-primary-500 hover:bg-primary-600 text-background-50 font-label font-medium rounded-full transition-all duration-300 text-sm cursor-pointer"
            >
              探索时尚穿搭
            </Link>
            <Link
              to="/about"
              className="whitespace-nowrap px-8 py-3.5 border border-background-200/50 text-background-50 hover:bg-background-50/10 font-label font-medium rounded-full transition-all duration-300 text-sm cursor-pointer"
            >
              了解更多
            </Link>
          </div>
        </div>
      </div>

      <div className="absolute bottom-0 left-0 right-0 z-10">
        <div className="max-w-5xl mx-auto px-4 md:px-6 pb-10">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6">
            {stats.map((stat) => (
              <div key={stat.label} className="text-center">
                <p className="font-heading text-2xl md:text-3xl font-semibold text-white" style={{ fontFamily: 'var(--font-heading)' }}>
                  {stat.value}
                </p>
                <p className="text-xs md:text-sm text-background-200/80 mt-1 font-label">
                  {stat.label}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}